import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { IRoute } from "./RouteInterface";
import { RouteWithSubRoutes } from "./RouteWithSubRoutes";
import { UpdateIntercom } from "../components/utility/intercom";

interface IProps {
  routes: IRoute[];
}

export const Router: React.FC<IProps> = ({ routes }) => {
  UpdateIntercom();
  return (
    <Switch>
      {routes
        .filter((route: IRoute) => route.path) // Filter out routes without a path
        .map((route: IRoute) => {
          // Generate a key from the path (handle both string and array)
          const keyPath = Array.isArray(route.path) ? route.path.join("-") : route.path;
          return <RouteWithSubRoutes key={keyPath} {...route} />;
        })}
      <Redirect from="*" to="/signin" />
    </Switch>
  );
};
